import { render } from "./PageGateOrders.vue?vue&type=template&id=923e29ca"
import script from "./PageGateOrders.vue?vue&type=script&lang=js"
export * from "./PageGateOrders.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__